import { render } from "./ToTopComponent.vue?vue&type=template&id=4d6dd3df&scoped=true"
import script from "./ToTopComponent.vue?vue&type=script&lang=js"
export * from "./ToTopComponent.vue?vue&type=script&lang=js"

import "./ToTopComponent.vue?vue&type=style&index=0&id=4d6dd3df&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d6dd3df"]])

export default __exports__